import { useTranslation } from "react-i18next";
import { OwnerPackagesPanel } from "@/components/packages/OwnerPackagesPanel";

interface PetItem {
  id: string;
  name: string;
}

interface MobileOwnerPackagesTabProps {
  ownerId: string;
  ownerName: string;
  clinicId: string | null;
  petIds: string[];
  pets: PetItem[];
}

export function MobileOwnerPackagesTab({
  ownerId,
  ownerName,
  clinicId,
  petIds,
  pets,
}: MobileOwnerPackagesTabProps) {
  const { t } = useTranslation("patients");
  if (!clinicId) {
    return (
      <div className="bg-card border border-border/60 rounded-[20px] p-6 text-sm text-muted-foreground shadow-soft-card">
        {t("ownerProfile.packagesClinicRequired")}
      </div>
    );
  }
  return (
    <OwnerPackagesPanel
      ownerId={ownerId}
      clinicId={clinicId}
      ownerName={ownerName}
      petIds={petIds}
      pets={pets}
    />
  );
}
